import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {BillingProduct, Product} from '../models/product';

export const  billingProductsActionTypes = {
  LOAD: type('[ Billing Products] Load'),
  LOAD_SUCCESS: type('[ Billing Products] Load Success'),
  LOAD_FAIL: type('[ Billing Products] Load Error')
};

export class LoadBillingProductsAction implements Action {
  readonly type =  billingProductsActionTypes.LOAD;
  constructor() {}
}

export class LoadBillingProductsSuccessAction implements Action {
  readonly type =  billingProductsActionTypes.LOAD_SUCCESS;
  constructor(public payload?: BillingProduct[]) {}
}

export class LoadBillingProductsFailAction implements Action {
  readonly type =  billingProductsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
